import IComponent from "components/commons/IComponent";
import SwitchButton from "components/commons/SwitchButton";
import MiniPanel from "components/commons/MiniPanel";
import OpacitySlider from "./OpacitySlider";
import LayerDropDown from "./LayerDropDown";
import GetArcGISToken from "utils/GetArcGISToken";
import "./LayerSetting.scoped.css";

let cachedMultiLevelDef = {};
class OverlayList extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  moveLayerOrder(layer, order) {
    var orderedGroup = this.props.mapView.map.allLayers.find(
      (i) => i.title === "Overlays Ordered Layers"
    );
    if (orderedGroup) {
      let layerList = this.$config[
        `mapList${this.props.isSecondMap ? "2" : ""}`
      ];
      let realOrder = orderedGroup.layers.length - 1 - order;
      orderedGroup.reorder(layer, realOrder);
      var orderLut = orderedGroup.layers
        .concat()
        .reverse()
        .reduce((p, c, i) => {
          p[c.title] = i;
          return p;
        }, {});
      layerList.overlays.forEach((i) => {
        if (i.title in orderLut) i.seq = orderLut[i.title];
      });
      this.setState({});
    }
  }

  makeMultiLevelLut(layer) {
    if (cachedMultiLevelDef[layer.id]) return cachedMultiLevelDef[layer.id];
    var output = layer.allSublayers
      .map((i) => [i, i.title, i.parent.title])
      .sort((a, b) => a[0].id - b[0].id)
      .reduce((p, c, i) => {
        if (!(c[2] in p)) p[c[2]] = [];
        p[c[2]].push({
          layer: c[0],
          title: c[1],
          parent: c[2],
        });
        return p;
      }, {});
    console.debug(output);
    if (Object.keys(output).lenght > 0) cachedMultiLevelDef[layer.id] = output;
    return output;
  }

  render() {
    let layerList = this.$config[`mapList${this.props.isSecondMap ? "2" : ""}`];
    if (!layerList) return <div />;
    let vm = this;
    let showActiveItemOnly = this.props.showActiveItem;
    let all2DLayers = layerList.layer2D;
    console.log(layerList);
    return (
      <div className="Overlay">
        <div>
          <span>Display Order</span>
          <span
            className="icn_black_24dp"
            style={{
              float: "right",
              margin: "-5px 0px 0px 0px",
              backgroundSize: "auto",
              filter:
                "invert(43%) sepia(90%) saturate(3322%) hue-rotate(8deg) brightness(104%) contrast(105%)",
            }}
          />
        </div>
        <table className="OverlayTable">
          <tbody>
            {layerList.overlays
              .concat()
              .sort((a, b) => a.seq - b.seq)
              .filter(
                (i) =>
                  i.layer &&
                  "seq" in i &&
                  (!showActiveItemOnly ||
                    (showActiveItemOnly && i.layer.visible))
              )
              .map((c, i, a) => {
                let l = c.layer;
                if ("seq" in c && !("Group" in c)) {
                  console.log("info", c);
                  if ("seq" in c) {
                    i = c.seq;
                    return (
                      <tr key={`Row${i}`}>
                        <td className="td">
                          {/* <span className="button icn_movedown"/> */}
                          {i > -1 && (
                            <span
                              className={`button icn_${
                                i == 0 ? "movedown" : "moveup"
                              }`}
                              onClick={() =>
                                this.moveLayerOrder(l, i === 0 ? 1 : i - 1)
                              }
                            />
                          )}
                        </td>
                        <td>
                          <MiniPanel
                            collapsed={!l.visible}
                            titleText={
                              <SwitchButton
                                label={l.title || <i>Loading...</i>}
                                placeAtRight={true}
                                checked={l.visible}
                                onClick={() => {
                                  l.visible = !l.visible;

                                  if (
                                    l.title === "Man Made Slope" &&
                                    all2DLayers.some((i) => i.layer.visible) ==
                                      true
                                  ) {
                                    let layer2DIdx = all2DLayers.findIndex(
                                      (i) => i.layer.visible
                                    );
                                    console.log(layer2DIdx);
                                    layer2DIdx =
                                      layer2DIdx == -1 ? undefined : layer2DIdx;
                                    let layer =
                                      all2DLayers?.[layer2DIdx]?.layer;
                                    let MMS = this.makeMultiLevelLut(layer)[
                                      "Slope and Catchment"
                                    ]?.filter(
                                      (l) => l.title === "Man-made Features"
                                    );
                                    if (MMS) {
                                      MMS[0].layer.visible = l.visible;
                                    }

                                    let MMS_2 = this.makeMultiLevelLut(layer)[
                                      "Slope"
                                    ]?.filter(
                                      (l) => l.title === "Man-made Features"
                                    );
                                    if (MMS_2) {
                                      MMS_2[0].layer.visible = l.visible;
                                    }

                                    let SI = this.makeMultiLevelLut(layer)[
                                      "Annotation"
                                    ]?.filter(
                                      (l) => l.title === "Slope Features"
                                    );

                                    if (SI) {
                                      SI[0].layer.visible = l.visible;
                                    }
                                  }

                                  vm.props.showDialog({ isOpen: false });
                                  this.setState();
                                }}
                              />
                            }
                          >
                            {c.lyType == "group" && (
                              <LayerDropDown
                                layers={c.layer.layers}
                                activeLayer={c.activeLayer || 0}
                                onChange={(e) => {
                                  c.activeLayer = e;
                                  c.layer.layers.forEach((lyr, i) => {
                                    lyr.visible = i === e;
                                  });
                                  vm.props.showDialog({ isOpen: false });
                                }}
                              />
                            )}
                            {c.transparency && (
                              <OpacitySlider
                                layer={
                                  c.lyType === "group"
                                    ? c.layers[c.activeLayer || 0]?.layer
                                    : l
                                }
                              />
                            )}
                          </MiniPanel>
                        </td>
                      </tr>
                    );
                  }
                }
              }, [])}
            <tr style={{ height: "20px" }}>
              <td colSpan={2} />
            </tr>
            {layerList.overlays.reduce((p, c, i) => {
              let l = c.layer;
              if (!l || "seq" in c) return p;
              if (showActiveItemOnly && !l.visible) return p;
              if (
                l.title === "MTR Proposed Protection Area" &&
                !(
                  GetArcGISToken.user.userGroup === 1 ||
                  GetArcGISToken.user.userGroup === 2 ||
                  GetArcGISToken.user.userGroup === 8
                )
              )
                return p;
              // if(c.title != 'Man Made Slope'){
              p.push(
                <tr key={`Row${i}`}>
                  {/* <td> */}
                  {/* <span className="button icn_movedown" /> */}
                  {/* </td> */}
                  <td colSpan={2}>
                    <MiniPanel
                      collapsed={!l.visible}
                      titleText={
                        <SwitchButton
                          label={l.title || <i>Loading...</i>}
                          placeAtRight={true}
                          checked={l.visible}
                          onClick={() => {
                            l.visible = !l.visible;
                            vm.setState({});
                            if (l.visible === true && l.title === "Grid Line") {
                              // console.log(l);
                              let idLists = l.allSublayers.items
                                .map((i) => i.id)
                                .sort((a, b) => a - b);
                              l.customParameters = {
                                layers: `show:${idLists.join(",")}`,
                              };
                            }
                          }}
                          style={{ width: "22px" }}
                        />
                      }
                    >
                      {c.transparency && <OpacitySlider layer={l} />}
                    </MiniPanel>
                  </td>
                  {/* <td></td> */}
                </tr>
              );
              return p;
            }, [])}
          </tbody>
        </table>
      </div>
    );
  }
}

export default OverlayList;
